/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Image = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M23 3V21H1V3H23ZM15.981 10.772L9.49951 16.5595L9.05212 16.9589L8.56407 16.6103L5.505 14.425L2.5 16.629V19.5H21.5V16.07L15.981 10.772ZM21.5 4.5H2.5V14.769L5.05648 12.8952L5.49421 12.5742L8.947 15.041L15.5005 9.19055L16.0185 8.72807L16.5194 9.20896L21.5 13.99V4.5ZM8.5 6C9.88071 6 11 7.11929 11 8.5C11 9.88071 9.88071 11 8.5 11C7.11929 11 6 9.88071 6 8.5C6 7.11929 7.11929 6 8.5 6ZM8.5 7.5C7.94772 7.5 7.5 7.94772 7.5 8.5C7.5 9.05228 7.94772 9.5 8.5 9.5C9.05229 9.5 9.5 9.05228 9.5 8.5C9.5 7.94772 9.05229 7.5 8.5 7.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
